import { render } from "./CompanyDeatils.vue?vue&type=template&id=5c7a5d3a&ts=true"
import script from "./CompanyDeatils.vue?vue&type=script&lang=ts"
export * from "./CompanyDeatils.vue?vue&type=script&lang=ts"

import "./CompanyDeatils.vue?vue&type=style&index=0&id=5c7a5d3a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__